import React, { useState } from 'react';
import './Header.css';
import Logo from './img/logo/TC-LOGO.png';
import basketicon from './img/icons/basket.png'
import searchicon from './img/icons/search.png'
import './dropdownbar.css';
import { useStateValue } from './StateProvider';
import { Link, useHistory } from 'react-router-dom';
import './MediaQuery.css';

function Header() {
  const [{ basket, user }, dispatch] = useStateValue();
  const [search, setSearch] = useState('');
  const [checked, setChecked] = useState(false);
  const [searchchecked, setSearchchecked] = useState(false);
  const history = useHistory();
  
  function toggle(value){
    return !value;
  }

  const onSubmit = () => {
    setSearch('')
  }

  const removeUser = () => {

    dispatch({
      type: 'SET_USER',
      user: []
    })

    localStorage.removeItem('usertalking');
    
  }

  return (
    <div className='header'>
        <Link to='/'>
          <div className='header__left'>
              <img className={searchchecked ? 'desactive-logo' : 'header__logo'} src={Logo} />
          </div>
        </Link>
        <div className='header__right'>
          {/*<input 
            className={searchchecked ? 'active-search-input' : 'search-input'}
            value={search} onChange={e => setSearch(e.target.value)}
            name="search"
          ></input>
          <Link to={`/search/${search}`}>
            <button 
              className={searchchecked ? 'active-search-btn2' : 'search-input'}
            >search</button>
  </Link>*/}
          <a href='https://wa.me/+263772566468' target='_blank' ><label className={searchchecked ? 'desactive-label flex_row_label' : 'header__label flex_row_label'}>+263 7 72566468 </label></a>
          {<label className={searchchecked ? 'desactive-label' : 'header__labell'}>|</label>}
          <Link to={user?.length === 0 ? `/signin` : `/`}>
            {
              user?.length === 0 
                ? <label className={'header__label login_btn flex_row_label'}>Sign in</label> 
                : <label onClick={removeUser} className={'header__label login_btn flex_row_label'}>Sign out</label>
            }
          </Link>
          <Link to={basket?.length === 0 ? '/' : '/checkout'}>
            <div className={searchchecked ? 'desactive-label' : 'header__basket'}>
              <img className='header__icon' src={basketicon} />
              <div className="header__addbag">
                  <label>
                      {basket.length}
                  </label>
              </div>
            </div>
          </Link>
          {/*<div className='dropdownbar'>
            <input className="search-btn" type="checkbox" id="search-btn" checked={searchchecked} onChange={() => setSearchchecked(toggle)}/>
            <label className="search-icon" for="search-btn"><img className={searchchecked ? 'desactive-label' : 'header__icon'} src={searchicon} /></label>
            <label className={!searchchecked ? 'active-close-btn' : "active-close-btn menu-icon"} for="search-btn"><span className="navicon"></span></label>
          </div>*/}
          <div className='dropdownbar'>
            <input className="menu-btn" type="checkbox" id="menu-btn" checked={checked} onChange={() => setChecked(toggle)}/>
            <label className="menu-icon" for="menu-btn"><span className="navicon"></span></label>
            <ul className={checked ? "active-menu" : "menu"}>
              {/*<li>
                <input className='search__input'></input>
                <button className='search__btn'>search</button>
              </li>*/}
              <Link to="/all-toys"><li onClick={() => setChecked(toggle)}><a href="">ALL TOYS</a></li></Link>
              <Link to="/best-sells"><li onClick={() => setChecked(toggle)}><a href="">BEST SELLS</a></li></Link>
              <Link to="/more-recents"><li onClick={() => setChecked(toggle)}><a href="">MORE RECENTS</a></li></Link>
              <Link to="/boys-toys"><li onClick={() => setChecked(toggle)}><a href="">BOYS TOYS</a></li></Link>
              <Link to="/girls-toys"><li onClick={() => setChecked(toggle)}><a href="">GIRLS TOYS</a></li></Link>
              
            </ul>
          </div>
        </div>
    </div>
  )
}

export default Header;